{{ displayPrice | priceValue:pricePrecision:displayCurrency?.value }}